import TeacherProfileBanner from './TeacherProfileBanner.component';

export default TeacherProfileBanner;
